// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3v2I2","left":"StickyBox_left__2UyaK","right":"StickyBox_right__1z5MB"};